var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-sheet',{attrs:{"height":"500"}},[_c('v-calendar',{attrs:{"now":_vm.today,"value":_vm.today,"color":"primary"},scopedSlots:_vm._u([{key:"day",fn:function(ref){
var present = ref.present;
var past = ref.past;
var date = ref.date;
return [_c('v-row',{staticClass:"fill-height"},[(past && _vm.tracked[date])?_vm._l((_vm.tracked[date]),function(percent,i){return _c('v-sheet',{key:i,attrs:{"title":_vm.category[i],"color":_vm.colors[i],"width":(percent + "%"),"height":"100%","tile":""}})}):_vm._e()],2)]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }